/**
 * - proxy: under our Next.js API (/api-next/trending-topics → /api/trending-topics)
 * - upstream: editorial-tools when calling the external API directly
 */
export const trendingTopicsRoutes = {
  topics: {
    proxy: 'trending-topics',
    upstream: 'trending-com/topics',
  },
} as const;
